import React from 'react';
import styles from './MultiSelectDropdown.module.scss';

type Props = {
  label: string;
  onRemove: (e?: React.MouseEvent) => void;
};

export default function Badge({ label, onRemove }: Props) {
  return (
    <div className={styles.badge}>
      <span className={styles.label}>{label}</span>
      <button
        onClick={(e) => {
          e.stopPropagation();
          onRemove(e);
        }}
        className={styles.remove}
        title="Remove"
        type="button"
      >
        ×
      </button>
    </div>
  );
}
